import React from 'react';
import PortfolioRoutes from './portfolio.routes';
import MainLayout from 'components/layouts/MainLayout';

const Admin = () => {
    return (
        <MainLayout>
            <PortfolioRoutes />
        </MainLayout>
    );
};

export default Admin;